var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo: "Editar Recepción de Información",
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          pasos: _vm.pasos,
          pasoActivoIndex: _vm.pasoActivoIndex,
          entidad: "Recepción de Información",
          estadoEntidad: _vm.estadoEntidad,
          inactivable: _vm.modificable,
          nombreEntidad: _vm.pasos.informacionGeneral.formState.entity
            ? _vm.pasos.informacionGeneral.formState.entity.nombre
            : "",
          mensajeInactivo: _vm.mensajeInactivo
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("RecepcionActividadForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              "test-id": "EditarRecepcionActividadModal",
              recepcionActividad: _vm.recepcionActividad,
              edicion: true
            },
            on: { change: _vm.handleFormChange }
          }),
          _c("AsociarFlotaEtiquetaVehiculoIndividual", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.asociarVehiculos.step,
                expression: "pasoActivoIndex === pasos.asociarVehiculos.step"
              }
            ],
            attrs: {
              "flotas-id-seleccionar":
                _vm.recepcionActividadDetalle &&
                _vm.recepcionActividadDetalle.flotasId,
              "etiquetas-id-seleccionar":
                _vm.recepcionActividadDetalle &&
                _vm.recepcionActividadDetalle.etiquetasId,
              "vehiculos-id-seleccionar":
                _vm.recepcionActividadDetalle &&
                _vm.recepcionActividadDetalle.vehiculosId,
              "col-def-vehiculo": _vm.vehiculoColDefs,
              esEditar: true,
              filtroGps: true
            },
            on: { change: _vm.handleAsociacionesChange }
          })
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.permiteContinuarConfirm,
          titulo: _vm.tituloPermiteContinuar,
          mensaje: _vm.mensajePermiteContinuar,
          items: _vm.itemsNoValidos,
          mostrarBoton: false
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.permiteContinuarConfirm = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }